export default __webpack_public_path__ + "static/media/Общие условия участия.9d1bfad4.docx";